// Chinese (Traditional / Taiwan)

export default {
  component: {
    supportLink: 'support@recright.com',

    layout: {
      endTime: date => (date ? `應聘時間截至 ${date}` : ''),
    },
    interview: {
      title: '回答影片面試問題',
      submit: '傳送回答並結束面試',
      continueLater: '稍後繼續',
      startInterview: '開始面試',
      duplicateError: '您已經參加了此面試。您收到了一封來自 invitations@recright.com 的電子郵件，其中包含一個可用於繼續面試的連結。',
      confirmSubmitHeader: '您沒有回答所有的面試問題',
      confirmSubmitContent: '您真的想結束面試嗎？',
      confirmSubmitContentWarning: '在這之後，您就不能完成您的回答了。',
      submitInterviewHeader: '提交您的面試回答',
      submitInterviewContent: '您確定要提交面試回答並結束面試嗎？',
      confirmSubmitButton: '傳送回答並結束面試',
      preview: '您可以在此預覽影片問題。',
      requiredQuestionsNotAnswered: '提交前請回答所有必填問題。',

      withdrawLink: '對這個職位不感興趣了？從此處退出流程。',
    },

    personalInterview: {
      title: '選擇合適的面試時間',
      description: [
        '您已被邀請參加一場面試。',
        '請選擇最適合您的時間。',
      ],
      position: '職位：',
      location: '地址：',
      time: '時間：',
      timezoneNotice: [
        '請注意，顯示的時間是您所在時區的時間。',
        '您所在的時區似乎是：',
        '預約面試時區是：',
      ],
      success: {
        title: '一切就緒！',
        description: '好極了！您已預約好一場面試！！下面是一些面試資訊：',
        linkDescription: [
          '您可以將此事項新增到下面的行事曆中。',
          '或者您也可以將連結複製到您的行事曆應用程式：',
        ],
        link: '新增到行事曆',
      },
    },

    interviewForm: {
      name: '姓名',
      city: '原籍',
      email: '電子郵件地址',
      phone: '電話號碼',
      link: '連結',
      legendBasicInfo: '基本資料',
      placeholderName: '輸入您的姓名',
      placeholderEmail: '輸入您的電子郵件地址',
      placeholderPhone: '輸入您的電話號碼',
      placeholderCity: '輸入您目前的常住地',
      placeholderLink: '新增連結，例如您的 LinkedIn 個人資料。',
      legendAttachments: '附件',
      legendAdditionalFields: '其他資訊',
      required: '標有星號 * 的項目為必填項目。',
    },

    sequencedInterview: {
      networkTest: {
        audio: '音訊',
        video: '影片',
        yes: '是',
        no: '否',
        supported: '支援',
        quality: '品質',
        header: '網路連線和裝置測試',
        description: '現在，我們將進行測試，以確保面試所需的網路連線和硬體（攝影機和麥克風）工作正常。出現提示時，請允許測試使用您的攝影機和麥克風，並確保攝影機沒有被遮住。此測試的時間約為 30 秒。我們建議您在硬體測試期間說幾句話進行測試。',
        inProgress: '測試中...',
        networkTestResults: '網路測試結果',
        qualityTestResults: '品質檢測結果',
        testPassedNetwork: '網路測試通過',
        testFailedNetwork: '網路測試未通過',
        testPassedQuality: '品質檢測通過',
        testFailedQuality: '品質檢測未通過',
        startTest: '開始測試',
        startInterview: '開始面試',
        testAgain: '再次測試',
        confirmTitle: '您即將開始面試',
        confirmWarning: '影片面試開始後，您將自動進入第一個面試問題。查看問題後，您將進入準備階段。',
        confirmText: '在回答每個問題之前，您有一小段時間進行準備。準備階段結束後，您有一段預先設定的時間來回答問題。請注意，即使預設的回答時間沒有結束，您也可以在準備就緒後立即提交回答。',
        confirmText2: '提交回答後，您將進入下一個問題，直到沒有問題為止。',
        confirmText3: '請注意，在錄製問題回答後，如果該問題允許重做，您將有 30 秒的時間重新回答。如果您在這 30 秒內沒有提出重做，您當前的回答將自動提交，您將進入下一個問題。',
        goodLuck: '深呼吸，您會成功的。祝您好運！',
        qualityRating: {
          excellent: '優秀',
          good: '良好',
          fair: '一般',
          poor: '不理想',
          bad: '較差',
        },
      },
      questionAnswerView: {
        title: title => `回答 ${title} 面試問題`,
        question: '問題',
        submitAndNext: '提交和下一題',
        submitAndFinish: '提交並完成面試',
        submitSuccess: '影片提交成功！',
        skipText: '開始錄製',
        stop: '停止',
        retake: '重做',
        take: '開始回答',
        takesLeft: '尚未回答的問題',
        skipTextQuestion: '準備好了嗎？繼續',
        retakeConfirmTitle: '您確定要重新回答這個問題嗎？',
        retakeConfirmSubmit: '是的，重新回答',
        submitInfoForward: '將於以下時間後自動提交當前回答並繼續',
        submitInfoForward2: '秒',
        nonAnswerableText: '此訊息無需回覆。在此訊息之後，您將直接進入下一個問題。',
        nonAnswerableVideo: '此影片無需回覆。在此影片之後，您將直接進入下一個問題。',
        answerTimeInfo: (answerMinutes, answerSeconds) =>
          `您有 ${answerMinutes} 分鐘和 ${answerSeconds} 秒的時間來回答問題。`,
      },
      publisher: {
        toNextQuestion: timer => `將在 ${timer} 後進入下一個問題`,
        recordingStarts: timer => `錄製將在 ${timer} 後開始`,
      },
      errors: {
        tooManyConnections: '此連線已關閉，因為您已在另一個標籤頁或視窗中打開了一個連線。',
        unsupportedBrowser: '很遺憾，您的瀏覽器不支援此操作。請使用其他瀏覽器。',
        networkError: '無網際網路連線。',
        reconnecting: '連線中斷。正在嘗試重新連線。',
        generalError: '出現錯誤。請重新整理頁面並重試。',
        allowMediaDevicesError: '此操作未能找到媒體裝置（攝影機或麥克風）。請確保您已允許瀏覽器使用您的攝影機和麥克風。',
        noAvailableDevicesError: '我們未能找到攝影機或麥克風。請確保您已允許瀏覽器使用攝影機和麥克風，且它們未被其他應用程式使用，然後再試一次。',
        initPublisherError: '因出現錯誤，操作失敗。請確保您已允許瀏覽器使用攝影機和麥克風，且它們未被其他應用程式使用，然後再試一次。',
      },
      browserInfo: {
        browserSupportTitle: '支援的瀏覽器',
        supportedBrowsers: '此測試和面試支援最新版本的 Chrome、Firefox、Safari 和 Edge。',
        mobileSupported: '行動裝置上支援的瀏覽器',
        android: 'Android：Google Chrome（最新發佈版本）、Firefox（最新發佈版本）',
        iOS: 'iOS：Safari（最新發佈版本）',
        latestVersion: '請確保您使用的是最新版本的瀏覽器。這是為了確保所有裝置運行流暢。',
        freezeInstruction: '如果視影片製沒有開始或錄製螢幕一直黑屏，請重新整理頁面。',
        unsupportedOnIos: '似乎您在 iOS 系統上使用的瀏覽器是我們不支援的瀏覽器。請使用 Safari。',
        ieUnsupported: '您使用的似乎是 Internet Explorer。很遺憾，此測試或面試不支援 Internet Explorer 瀏覽器。請使用其他瀏覽器。',
        qualityTestNotSupported: '很遺憾，您使用的瀏覽器不支援此硬體測試。您可以在不測試音訊和影片品質的情況下繼續進行面試，或者使用其他瀏覽器。',
      },
      reconnectSuccess: '重新連線成功！',
      continue: '繼續',
    },

    withdraw: {
      title: '對這個職位不感興趣了？',
      description: '退出招聘程序。',
      buttonText: '退出招聘程序',
      thankYouTitle: '謝謝！',
      thankYouText: '您現在已退出招聘程序。',
      confirm: '您確定要退出招聘程序嗎？退出後，您將無法再參加此面試或與此職位相關的任何其他面試。',
    },
  },

  page: {
    supportLink: 'support@recright.com',

    embeddedProfileInterview: {
      submit: '提交回答',
      continue: '繼續',
      supportCenter: 'Recright Help Center',
      thankYou: '謝謝您提交影片回答！我們將在近期與您聯繫！',
    },

    finished: {
      reopenDescription: '如果您不小心關閉了這次面試，不用擔心！您可以點擊下面的按鈕重新開始面試！',
      reopenButtonText: '重新開始面試',
      title: '感謝您接受此面試！',
      description1: '太棒了！現在，您已經回答了所有面試問題，您的回答正在傳送給招聘人員。敬請期待！',
      descriptionsupport: mailto => `如果您不小心關閉了這次面試，不用擔心！請透過 ${mailto} 聯絡我們的客戶支援部門，我們會為您重新安排面試。`,
      descriptionfeedback: '您的體驗對我們很重要！我們很想知道您在回答影片面試問題時的感受。我們可以在哪些方面改進我們的服務？歡迎在此處留下您的回饋意見：',
      feedbackbutton: '留下您的回饋意見',
      regularUrl: 'https://www.surveymonkey.com/r/B3ZCSWT',
      timedUrl: 'https://www.surveymonkey.com/r/MZMLPPT',
    },
    messages: {
      title: '個人訊息',
    },

    closed: {
      title: '面試已完成或面試已結束',
      description: '您受邀參加的影片面試已經結束，或者您已完成提交。',
      publicTitle: '面試已結束',
      publicDescription: '您要找的影片面試已經結束。',
    },
    saved: {
      title: '您的影片面試已儲存！',
      description: '如果您希望繼續影片面試，請使用您之前收到的電子郵件連結。已經錄製好的影片回答將在您回來繼續作答時為您準備好！祝您求職順利！',
      remember: '面試回答完畢後，記得將答案傳送給招聘人員。',
      deleteHistory: '如果您在公用電腦上進行影片面試，請記得清除瀏覽歷程記錄。這樣您的面試就安全了。',
    },
    unpublished: {
      title: '面試尚未開始',
      publishTime: publishTime => `面試將在 ${publishTime} 開始`,
    },
  },
}
